/**
 * Minha Conta Lev — storefront app (page + legacy customers/account).
 * Page mode: SES email OTP → httpOnly session → lev-minhaconta APIs.
 * Local: open http://127.0.0.1:9292/pages/minhacontalev with API on :3001.
 */
(function () {
  'use strict';

  var ROOT = document.getElementById('lev-minhaconta-root');
  if (!ROOT) return;

  var MODE = ROOT.getAttribute('data-mode') || 'account';
  var TROCA_URL = String(ROOT.getAttribute('data-troca-url') || '/pages/bikes');

  var TAB_LABELS = {
    dados: 'Dados pessoais',
    levprime: 'Lev Prime',
    enderecos: 'Endereços',
    meuspedidos: 'Meus Pedidos',
    troca: 'Transferência de Propriedade',
  };

  var state = {
    tab: 'dados',
    email: '',
    lookupEmail: '',
    showClientSearch: false,
    profile: null,
    address: null,
    profileSnapshot: null,
    addressSnapshot: null,
    levPrimeVisible: false,
    pendingEmail: '',
    challenge: '',
    bound: false,
  };

  var LOCAL_API = 'http://127.0.0.1:3001';
  var NETLIFY_API = 'https://lev-minhaconta.netlify.app';
  // Cross-origin Shopify → Netlify cannot rely on third-party cookies; keep the
  // session JWT in localStorage and send Authorization: Bearer on every call.
  var SESSION_TOKEN_KEY = 'lev_mc_session_token';

  function getSessionToken() {
    try {
      return localStorage.getItem(SESSION_TOKEN_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function setSessionToken(token) {
    if (!token) return;
    try {
      localStorage.setItem(SESSION_TOKEN_KEY, String(token));
    } catch (e) {}
  }

  function clearSessionToken() {
    try {
      localStorage.removeItem(SESSION_TOKEN_KEY);
    } catch (e) {}
  }

  function resolveApiBase() {
    var params = new URLSearchParams(window.location.search);
    var apiParam = params.get('api');
    if (apiParam === 'local') {
      try {
        localStorage.setItem('lev_mc_api_base', LOCAL_API);
      } catch (e) {}
      return LOCAL_API;
    }
    if (apiParam === 'netlify') {
      try {
        localStorage.setItem('lev_mc_api_base', NETLIFY_API);
      } catch (e) {}
      return NETLIFY_API;
    }
    var host = window.location.hostname;
    // Theme on loopback must call API on the same host — cookies are host-bound.
    if (host === '127.0.0.1' || host === 'localhost') {
      try {
        localStorage.setItem('lev_mc_api_base', LOCAL_API);
      } catch (e) {}
      return LOCAL_API;
    }
    try {
      var stored = localStorage.getItem('lev_mc_api_base');
      if (stored) {
        stored = String(stored).replace(/\/$/, '');
        if (
          stored.indexOf('127.0.0.1') === -1 &&
          stored.indexOf('localhost') === -1
        ) {
          return stored;
        }
      }
    } catch (e) {}
    var fromTheme = String(ROOT.getAttribute('data-api-base') || '').replace(
      /\/$/,
      ''
    );
    if (
      !fromTheme ||
      fromTheme.indexOf('127.0.0.1') !== -1 ||
      fromTheme.indexOf('localhost') !== -1
    ) {
      return NETLIFY_API;
    }
    return fromTheme;
  }

  var API_BASE = resolveApiBase();
  try {
    console.info('[lev-minhaconta] API_BASE =', API_BASE);
  } catch (e) {}

  function qs(sel, el) {
    return (el || ROOT).querySelector(sel);
  }

  function qsa(sel, el) {
    return Array.prototype.slice.call((el || ROOT).querySelectorAll(sel));
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function showMessage(el, text) {
    if (!el) return;
    if (text) {
      el.textContent = text;
      setHidden(el, false);
    } else {
      el.textContent = '';
      setHidden(el, true);
    }
  }

  function clearSession() {
    state.email = '';
    state.lookupEmail = '';
    state.showClientSearch = false;
    state.pendingEmail = '';
    state.challenge = '';
    state.profile = null;
    state.address = null;
    clearSessionToken();
  }

  function api(path, options) {
    options = options || {};
    var headers = Object.assign(
      {
        'Content-Type': 'application/json',
      },
      options.headers || {}
    );
    var token = getSessionToken();
    if (token && !headers.Authorization && !headers.authorization) {
      headers.Authorization = 'Bearer ' + token;
    }
    return fetch(
      API_BASE + path,
      Object.assign({}, options, {
        headers: headers,
        credentials: 'include',
      })
    ).then(function (response) {
      if (response.status === 401 && token) clearSessionToken();
      return response;
    });
  }

  function setInputsReadonly(form, readonly) {
    qsa('input', form).forEach(function (input) {
      if (input.name === 'email' || input.name === 'postalCode' || input.disabled) return;
      if (readonly) input.setAttribute('readonly', '');
      else input.removeAttribute('readonly');
    });
    qsa('select', form).forEach(function (select) {
      select.disabled = readonly;
    });
  }

  function formatCep(value) {
    var digits = String(value || '').replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 5) return digits;
    return digits.slice(0, 5) + '-' + digits.slice(5);
  }

  function fillProfileForm(profile) {
    var form = qs('[data-profile-form]');
    if (!form || !profile) return;
    form.firstName.value = profile.firstName || '';
    form.lastName.value = profile.lastName || '';
    form.email.value = profile.email || state.email;
    form.phone.value = profile.phone || '';
    form.document.value = profile.document || '';
  }

  function fillAddressForm(address) {
    var form = qs('[data-address-form]');
    if (!form) return;
    var a = address || {};
    form.addressId.value = a.id || '';
    form.name.value =
      a.name || a.addressName || a.receiverName || 'Endereço Principal';
    form.postalCode.value = formatCep(a.postalCode || '');
    form.street.value = a.street || '';
    form.number.value = a.number || '';
    form.complement.value = a.complement || '';
    form.neighborhood.value = a.neighborhood || '';
    form.city.value = a.city || '';
    form.state.value = a.state || '';
  }

  function setTab(tab) {
    if (tab === 'troca') {
      window.location.href = TROCA_URL;
      return;
    }

    state.tab = tab;

    qsa('[data-tab]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-tab') === tab);
    });

    qsa('[data-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-panel') === tab;
      panel.classList.toggle('is-active', active);
      setHidden(panel, !active);
    });

    var label = qs('[data-mobile-label]');
    if (label) label.textContent = TAB_LABELS[tab] || tab;

    var mobileNav = qs('[data-mobile-nav]');
    var chevron = qs('[data-mobile-chevron]');
    var toggle = qs('[data-mobile-toggle]');
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (chevron) chevron.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    if (tab === 'meuspedidos') {
      if (MODE === 'page') loadVtexOrders(false);
      loadStoreOrders(false);
    }
    if (tab === 'levprime') loadLevPrime(true);
  }

  function tabFromLocation() {
    try {
      var hash = String(window.location.hash || '')
        .replace(/^#/, '')
        .trim()
        .toLowerCase();
      if (hash === 'meuspedidos' || hash === 'pedidos') return 'meuspedidos';
      var params = new URLSearchParams(window.location.search);
      var tab = String(params.get('tab') || '')
        .trim()
        .toLowerCase();
      if (tab === 'meuspedidos' || tab === 'pedidos') return 'meuspedidos';
    } catch (e) {}
    return '';
  }

  function applyTabFromLocation() {
    var tab = tabFromLocation();
    if (tab) setTab(tab);
  }

  window.addEventListener('hashchange', applyTabFromLocation);

  function ordersEmail() {
    return String(state.lookupEmail || state.email || '')
      .trim()
      .toLowerCase();
  }

  function setClientSearchVisible(visible) {
    state.showClientSearch = !!visible;
    var panel = qs('[data-client-search]');
    setHidden(panel, !visible);
    if (!visible) return;
    var input = qs('[data-client-search-input]');
    if (input) {
      if (!input.value) input.value = state.lookupEmail || state.email || '';
      window.setTimeout(function () {
        input.focus();
        input.select();
      }, 0);
    }
  }

  function setLookupEmail(email) {
    state.lookupEmail = String(email || '')
      .trim()
      .toLowerCase();
    var active = qs('[data-client-search-active]');
    if (active) {
      if (state.lookupEmail) {
        active.textContent = 'Exibindo pedidos de: ' + state.lookupEmail;
        setHidden(active, false);
      } else {
        active.textContent = '';
        setHidden(active, true);
      }
    }
  }

  function resetStoreOrdersCache() {
    var storeBox = qs('[data-store-orders]');
    if (!storeBox) return;
    storeBox.removeAttribute('data-loaded');
    storeBox.removeAttribute('data-loaded-email');
  }

  function resetVtexOrdersCache() {
    var box = qs('[data-vtex-orders]');
    if (!box) return;
    box.removeAttribute('data-loaded');
    box.removeAttribute('data-loaded-email');
  }

  function setLevPrimeVisible(visible) {
    state.levPrimeVisible = !!visible;
    qsa('[data-levprime-nav]').forEach(function (btn) {
      setHidden(btn, !visible);
    });
    ROOT.classList.toggle('lev-mc--prime', !!visible);
    if (!visible && state.tab === 'levprime') {
      setTab('dados');
    }
  }

  function setEditMode(kind, editing) {
    if (kind === 'profile') {
      var form = qs('[data-profile-form]');
      setInputsReadonly(form, !editing);
      setHidden(qs('[data-profile-actions]'), !editing);
      setHidden(qs('[data-profile-edit]'), editing);
      if (editing) state.profileSnapshot = JSON.parse(JSON.stringify(state.profile || {}));
    } else {
      var aform = qs('[data-address-form]');
      setInputsReadonly(aform, !editing);
      setHidden(qs('[data-address-actions]'), !editing);
      setHidden(qs('[data-address-edit]'), editing);
      setHidden(qs('[data-address-editing]'), !editing);
      if (editing) state.addressSnapshot = JSON.parse(JSON.stringify(state.address || {}));
    }
  }

  function showGate() {
    setHidden(qs('[data-auth-gate]'), false);
    setHidden(qs('[data-account-app]'), true);
    setHidden(qs('[data-auth-email-form]'), false);
    setHidden(qs('[data-auth-code-form]'), true);
    showMessage(qs('[data-auth-error]'), '');
  }

  function showApp() {
    setHidden(qs('[data-auth-gate]'), true);
    setHidden(qs('[data-account-app]'), false);
  }

  async function loadProfile() {
    var boot = qs('[data-boot]');
    var notice = qs('[data-sankhya-notice]');
    setHidden(boot, false);
    showMessage(qs('[data-profile-error]'), '');

    try {
      var res = await api('/api/minhacontalev/profile');
      var data = await res.json().catch(function () {
        return {};
      });

      if (!res.ok) {
        if (res.status === 401) {
          clearSession();
          syncNavUser(null);
          showGate();
          return;
        }
        throw new Error(data.message || 'Erro ao carregar perfil');
      }

      state.profile = {
        id: data.id || data.codparc || '',
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        email: data.email || state.email,
        document: data.document || '',
        phone: data.phone || '',
      };

      // Only surface the Sankhya notice when we have a linked partner but no address yet.
      showMessage(notice, '');

      fillProfileForm(state.profile);

      var addresses = Array.isArray(data.addresses) ? data.addresses : [];
      if (addresses.length) {
        state.address = addresses[0];
        fillAddressForm(state.address);
      } else {
        var addrRes = await api('/api/minhacontalev/addresses');
        if (addrRes.ok) {
          var addrData = await addrRes.json();
          var list = Array.isArray(addrData.addresses) ? addrData.addresses : [];
          state.address = list[0] || null;
          fillAddressForm(state.address);
          if (!state.address) setEditMode('address', true);
        }
      }
    } catch (err) {
      console.error('[lev-minhaconta] profile', err);
      state.profile = {
        id: '',
        firstName: '',
        lastName: '',
        email: state.email,
        document: '',
        phone: '',
      };
      fillProfileForm(state.profile);
      showMessage(
        qs('[data-profile-error]'),
        (err && err.message) ||
          'Não foi possível carregar o perfil. Confira se a API local está em ' +
            API_BASE
      );
    } finally {
      setHidden(boot, true);
      qsa('[data-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-panel') === state.tab;
        setHidden(panel, !active);
      });
    }
  }

  async function saveProfile(e) {
    e.preventDefault();
    var form = qs('[data-profile-form]');
    var saveBtn = qs('[data-profile-save]');
    showMessage(qs('[data-profile-error]'), '');
    saveBtn.disabled = true;

    var body = {
      id: (state.profile && state.profile.id) || '',
      firstName: form.firstName.value.trim(),
      lastName: form.lastName.value.trim(),
      email: state.email,
      document: form.document.value.trim(),
      phone: form.phone.value.trim(),
    };

    try {
      var res = await api('/api/minhacontalev/update-profile', {
        method: 'POST',
        body: JSON.stringify(body),
      });
      var data = await res.json().catch(function () {
        return {};
      });
      if (!res.ok) throw new Error(data.message || 'Erro ao salvar dados');
      state.profile = Object.assign({}, state.profile, body);
      setEditMode('profile', false);
    } catch (err) {
      showMessage(qs('[data-profile-error]'), err.message || 'Erro ao salvar');
    } finally {
      saveBtn.disabled = false;
    }
  }

  async function saveAddress(e) {
    e.preventDefault();
    var form = qs('[data-address-form]');
    var saveBtn = qs('[data-address-save]');
    showMessage(qs('[data-address-error]'), '');
    saveBtn.disabled = true;

    var address = {
      name: form.name.value.trim(),
      street: form.street.value.trim(),
      number: form.number.value.trim(),
      complement: form.complement.value.trim(),
      neighborhood: form.neighborhood.value.trim(),
      city: form.city.value.trim(),
      state: form.state.value.trim(),
      postalCode: form.postalCode.value.trim(),
      country: 'BRA',
      isDefault: state.address ? state.address.isDefault !== false : true,
    };

    try {
      var res = await api('/api/minhacontalev/update-address', {
        method: 'POST',
        body: JSON.stringify({
          email: state.email,
          addressId: form.addressId.value.trim(),
          address: address,
          firstName: (state.profile && state.profile.firstName) || '',
          lastName: (state.profile && state.profile.lastName) || '',
          document: (state.profile && state.profile.document) || '',
          phone: (state.profile && state.profile.phone) || '',
        }),
      });
      var data = await res.json().catch(function () {
        return {};
      });
      if (!res.ok) throw new Error(data.message || 'Erro ao salvar endereço');
      state.address = Object.assign({}, address, { id: form.addressId.value.trim() });
      setEditMode('address', false);
    } catch (err) {
      showMessage(qs('[data-address-error]'), err.message || 'Erro ao salvar');
    } finally {
      saveBtn.disabled = false;
    }
  }

  var shopifyImageCache = {};

  function normalizeProductName(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function shopifyImageUrl(product) {
    var featured = product && product.featured_image && product.featured_image.url;
    var image = String(featured || (product && product.image) || '');
    if (image.indexOf('//') === 0) image = 'https:' + image;
    if (!image) return '';
    if (image.indexOf('cdn.shopify.com') !== -1 && !/[?&]width=/.test(image)) {
      image += (image.indexOf('?') === -1 ? '?' : '&') + 'width=160';
    }
    return image;
  }

  function scoreShopifyProduct(product, item) {
    var title = normalizeProductName(product && product.title);
    var name = normalizeProductName(item && item.name);
    if (!title || !name) return 0;
    if (title === name) return 100;
    if (name.indexOf(title) !== -1) return 80 + Math.min(title.length, 19);
    if (title.indexOf(name) !== -1) return 75;
    var nameTokens = name.split(' ').filter(function (token) {
      return token.length > 2;
    });
    var titleTokens = title.split(' ');
    if (!nameTokens.length) return 0;
    var hits = 0;
    nameTokens.forEach(function (token) {
      if (titleTokens.indexOf(token) !== -1) hits += 1;
    });
    return Math.round((hits / nameTokens.length) * 60);
  }

  function suggestShopifyProducts(query) {
    var url =
      '/search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=8&resources[options][fields]=' +
      encodeURIComponent('title,variants.sku');
    return fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return [];
        return res.json();
      })
      .then(function (data) {
        var products =
          data &&
          data.resources &&
          data.resources.results &&
          data.resources.results.products;
        return Array.isArray(products) ? products : [];
      })
      .catch(function () {
        return [];
      });
  }

  function pickShopifyProduct(products, item, query) {
    var best = null;
    var bestScore = 0;
    var ref = String((item && item.refId) || '')
      .trim()
      .toLowerCase();
    var sku = String((item && item.skuId) || '')
      .trim()
      .toLowerCase();
    products.forEach(function (product) {
      var score = scoreShopifyProduct(product, item);
      var variants = Array.isArray(product.variants) ? product.variants : [];
      variants.forEach(function (variant) {
        var variantSku = String(variant.sku || '')
          .trim()
          .toLowerCase();
        if (ref && variantSku === ref) score = Math.max(score, 100);
        if (sku && variantSku === sku) score = Math.max(score, 95);
      });
      if (score > bestScore) {
        best = product;
        bestScore = score;
      }
    });
    var code = String(query || '').trim();
    if (
      bestScore < 60 &&
      products.length === 1 &&
      code &&
      code.indexOf(' ') === -1 &&
      code.length >= 3
    ) {
      return products[0];
    }
    return bestScore >= 60 ? best : null;
  }

  function lookupShopifyProductImage(item) {
    var key = [item.refId || '', item.skuId || '', item.name || '']
      .join('|')
      .toLowerCase();
    if (shopifyImageCache[key]) return shopifyImageCache[key];
    var queries = [];
    [item.name, item.refId, item.skuId].forEach(function (value) {
      var query = String(value || '').trim();
      if (query && queries.indexOf(query) === -1) queries.push(query);
    });
    shopifyImageCache[key] = queries
      .reduce(function (chain, query) {
        return chain.then(function (found) {
          if (found) return found;
          return suggestShopifyProducts(query).then(function (products) {
            var product = pickShopifyProduct(products, item, query);
            return product ? shopifyImageUrl(product) : '';
          });
        });
      }, Promise.resolve(''))
      .catch(function () {
        return '';
      });
    return shopifyImageCache[key];
  }

  function hydrateVtexProductImages(box) {
    qsa('[data-vtex-product-image]', box).forEach(function (slot) {
      lookupShopifyProductImage({
        name: slot.getAttribute('data-product-name') || '',
        refId: slot.getAttribute('data-product-ref') || '',
        skuId: slot.getAttribute('data-product-sku') || '',
      }).then(function (url) {
        if (!url || !slot.parentNode) return;
        var img = document.createElement('img');
        img.className = 'lev-mc__vtex-order-item-image';
        img.alt = slot.getAttribute('data-product-name') || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.addEventListener('error', function () {
          if (img.parentNode) img.parentNode.removeChild(img);
        });
        img.src = url;
        slot.parentNode.replaceChild(img, slot);
      });
    });
  }

  function vtexStatusLabel(status, description) {
    var key = String(status || '').toLowerCase();
    var labels = {
      invoiced: 'Faturado',
      'payment-approved': 'Pagamento aprovado',
      'payment-pending': 'Pagamento pendente',
      canceled: 'Cancelado',
      cancelled: 'Cancelado',
      cancel: 'Cancelado',
      handling: 'Em preparação',
      'ready-for-handling': 'Pronto para manuseio',
      'window-to-cancel': 'Janela de cancelamento',
      delivered: 'Entregue',
      shipped: 'Enviado',
    };
    return labels[key] || description || status || '—';
  }

  function formatLongDateBr(value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  }

  function vtexDeliveryEstimate(order) {
    var shipping = order.shipping || {};
    var estimateDate = shipping.estimateDate || order.shippingEstimateDate || '';
    var estimate = shipping.estimate || order.shippingEstimate || '';
    if (estimateDate) return formatLongDateBr(estimateDate);
    if (estimate) return String(estimate).replace(/bd\b/i, '').trim() + ' dias úteis';
    return 'Data não disponível';
  }

  function vtexOrderAddressHtml(order) {
    var address = order.shippingAddress || order.shipping_address || {};
    var receiver =
      address.name ||
      address.receiverName ||
      order.shippingReceiver ||
      order.shipping_receiver ||
      '';
    var street =
      address.street || order.shippingStreet || order.shipping_street || '';
    var number =
      address.number || order.shippingNumber || order.shipping_number || '';
    var complement =
      address.complement ||
      order.shippingComplement ||
      order.shipping_complement ||
      '';
    var neighborhood =
      address.neighborhood ||
      order.shippingNeighborhood ||
      order.shipping_neighborhood ||
      '';
    var city = address.city || order.shippingCity || order.shipping_city || '';
    var stateName =
      address.state || order.shippingState || order.shipping_state || '';
    var postalCode =
      address.postalCode ||
      address.postal_code ||
      order.shippingPostalCode ||
      order.shipping_postal_code ||
      '';
    var lines = [];

    if (receiver) lines.push('<strong>' + escapeHtml(receiver) + '</strong>');
    if (street || number || complement) {
      lines.push(
        escapeHtml(
          [street, number].filter(Boolean).join(' ') +
            (complement ? ', ' + complement : '')
        )
      );
    }
    if (neighborhood) lines.push(escapeHtml(neighborhood));
    if (city || stateName) {
      lines.push(
        escapeHtml([city, stateName].filter(Boolean).join(' - ') + ' - Brasil')
      );
    }
    if (postalCode) lines.push(escapeHtml(formatCep(postalCode)));

    return lines.length
      ? lines.join('<br>')
      : '<span class="lev-mc__vtex-order-unavailable">Endereço não disponível para este pedido.</span>';
  }

  function vtexOrderDetailsHtml(order, detailId, orderNumber, status) {
    var paymentData = order.paymentData || {};
    var paymentMethod =
      paymentData.method || order.paymentSystems || order.paymentNames || '—';
    var paymentDetail = paymentData.detail || order.paymentDetail || '';
    var subtotal =
      order.itemsTotal != null
        ? order.itemsTotal
        : order.subtotal != null
        ? order.subtotal
        : order.total;
    var discounts =
      order.discountsTotal != null
        ? order.discountsTotal
        : order.discounts != null
        ? order.discounts
        : 0;
    var total =
      order.total != null
        ? order.total
        : order.grandTotal != null
        ? order.grandTotal
        : order.totalValue;
    var whatsappUrl =
      'https://wa.me/5521980220130?text=' +
      encodeURIComponent(
        'Olá, gostaria de solicitar o cancelamento do pedido #' + orderNumber
      );

    return (
      '<section class="lev-mc__vtex-order-details" id="' +
      detailId +
      '" data-vtex-order-details hidden>' +
      '<div class="lev-mc__vtex-order-details-header">' +
      '<h3 class="lev-mc__vtex-order-details-title">Pedido #' +
      escapeHtml(orderNumber) +
      '</h3>' +
      '<div class="lev-mc__vtex-order-details-status-row">' +
      '<span class="lev-mc__vtex-order-details-date">' +
      escapeHtml(formatLongDateBr(order.createdAt || order.creationDate) || 'Data não disponível') +
      '</span>' +
      '<span class="lev-mc__badge lev-mc__vtex-order-details-status" data-status="' +
      escapeHtml(String(order.status || '').toLowerCase()) +
      '">' +
      escapeHtml(status) +
      '</span></div>' +
      '<a class="lev-mc__vtex-order-cancel" href="' +
      escapeHtml(whatsappUrl) +
      '" target="_blank" rel="noopener noreferrer">Solicitar cancelamento</a>' +
      '</div>' +
      '<div class="lev-mc__vtex-order-info-grid">' +
      '<div class="lev-mc__vtex-order-info-card">' +
      '<h4>Endereço</h4><div>' +
      vtexOrderAddressHtml(order) +
      '</div></div>' +
      '<div class="lev-mc__vtex-order-info-card">' +
      '<h4>Forma de Pagamento</h4><div>' +
      escapeHtml(paymentMethod) +
      (total != null ? ' ' + escapeHtml(formatMoneyBr(total)) : '') +
      (order.installments ? ' (' + escapeHtml(String(order.installments)) + ')' : '') +
      '<span class="lev-mc__vtex-order-info-extra">' +
      escapeHtml(paymentDetail || '+ Informações adicionais') +
      '</span></div></div>' +
      '<div class="lev-mc__vtex-order-info-card">' +
      '<h4>Resumo</h4><div class="lev-mc__vtex-order-totals">' +
      '<div><span>Subtotal</span><span>' +
      escapeHtml(formatMoneyBr(subtotal) || '—') +
      '</span></div>' +
      '<div><span>Descontos</span><span>' +
      escapeHtml(discounts ? '- ' + formatMoneyBr(Math.abs(Number(discounts))) : formatMoneyBr(0)) +
      '</span></div>' +
      '<div class="is-total"><span>Total</span><span>' +
      escapeHtml(formatMoneyBr(total) || '—') +
      '</span></div>' +
      '</div></div></div></section>'
    );
  }

  async function loadVtexOrders(force) {
    var box = qs('[data-vtex-orders]');
    if (!box) return;
    var email = String(state.email || '')
      .trim()
      .toLowerCase();
    if (!email) {
      box.innerHTML =
        '<div class="lev-mc__empty">Entre na sua conta para ver os pedidos do site.</div>';
      return;
    }
    if (
      !force &&
      box.getAttribute('data-loaded') === '1' &&
      box.getAttribute('data-loaded-email') === email
    ) {
      return;
    }

    box.innerHTML = '<div class="lev-mc__status">Carregando pedidos do site…</div>';

    try {
      var res = await api('/api/minhacontalev/vtex-orders');
      var data = await res.json().catch(function () {
        return {};
      });
      if (res.status === 401) {
        clearSession();
        syncNavUser(null);
        showGate();
        return;
      }
      if (!res.ok) throw new Error(data.message || 'Erro ao buscar pedidos do site');

      var orders = Array.isArray(data.orders) ? data.orders : [];
      if (!orders.length) {
        box.innerHTML =
          '<div class="lev-mc__empty">Nenhum pedido do site encontrado para este e-mail.</div>';
        box.setAttribute('data-loaded', '1');
        box.setAttribute('data-loaded-email', email);
        return;
      }

      var html = '';
      orders.forEach(function (order, orderIndex) {
        var sequence = String(order.sequence || '').trim();
        var orderId = String(order.orderId || '');
        var date = formatDateBr(order.createdAt || '');
        var total = formatMoneyBr(order.total);
        var status = vtexStatusLabel(order.status, order.statusDescription);
        var items = Array.isArray(order.items) ? order.items : [];
        var panelId = 'lev-mc-vtex-order-' + orderIndex;
        var detailId = panelId + '-details';
        var orderNumber = sequence || orderId || '—';
        var expanded = orderIndex < 2;
        html +=
          '<article class="lev-mc__vtex-order">' +
          '<div class="lev-mc__vtex-order-header" role="button" tabindex="0" data-vtex-order-toggle aria-controls="' +
          panelId +
          '" aria-expanded="' +
          (expanded ? 'true' : 'false') +
          '">' +
          '<div class="lev-mc__vtex-order-header-row">' +
          '<div class="lev-mc__vtex-order-header-col">' +
          '<span class="lev-mc__vtex-order-label">Pedido Realizado</span>' +
          '<span class="lev-mc__vtex-order-value">' +
          escapeHtml(date || 'Data não disponível') +
          '</span></div>' +
          '<div class="lev-mc__vtex-order-header-col">' +
          '<span class="lev-mc__vtex-order-label">Total</span>' +
          '<span class="lev-mc__vtex-order-value">' +
          escapeHtml(total || '—') +
          '</span></div></div>' +
          '<div class="lev-mc__vtex-order-header-row">' +
          '<div class="lev-mc__vtex-order-header-col">' +
          '<span class="lev-mc__vtex-order-label">Pedido No</span>' +
          '<span class="lev-mc__vtex-order-value">' +
          escapeHtml(orderNumber) +
          '</span></div>' +
          '<span class="lev-mc__vtex-order-chevron" aria-hidden="true"></span>' +
          '</div></div>' +
          '<div class="lev-mc__vtex-order-body" id="' +
          panelId +
          '"' +
          (expanded ? '' : ' hidden') +
          '><div class="lev-mc__vtex-order-main">' +
          '<div class="lev-mc__vtex-order-summary">' +
          '<div class="lev-mc__vtex-order-status-label">Entrega Estimada para</div>' +
          '<strong class="lev-mc__vtex-order-delivery-date">' +
          escapeHtml(vtexDeliveryEstimate(order)) +
          '</strong>' +
          '<button type="button" class="lev-mc__vtex-order-action" data-vtex-order-details-toggle aria-controls="' +
          detailId +
          '" aria-expanded="false">Ver detalhes do pedido</button>';
        if (order.invoiceNumbers) {
          html +=
            '<div class="lev-mc__vtex-order-invoice">Nota fiscal ' +
            escapeHtml(String(order.invoiceNumbers)) +
            '</div>';
        }
        html += '</div>';
        if (items.length) {
          html += '<ul class="lev-mc__vtex-order-items">';
          items.forEach(function (item) {
            var qty = Number(item.quantity) || 0;
            var line = formatMoneyBr(item.lineTotal != null ? item.lineTotal : item.price);
            html +=
              '<li class="lev-mc__vtex-order-item">' +
              '<span class="lev-mc__vtex-order-item-placeholder" data-vtex-product-image data-product-name="' +
              escapeHtml(item.name || '') +
              '" data-product-ref="' +
              escapeHtml(item.refId || '') +
              '" data-product-sku="' +
              escapeHtml(item.skuId || '') +
              '" aria-hidden="true"></span>' +
              '<span class="lev-mc__vtex-order-item-copy"><strong>' +
              escapeHtml(item.name || 'Produto') +
              '</strong><small>' +
              escapeHtml(String(qty || 1)) +
              ' un</small></span>' +
              (line
                ? '<strong class="lev-mc__vtex-order-item-price">' +
                  escapeHtml(line) +
                  '</strong>'
                : '') +
              '</li>';
          });
          html += '</ul>';
        } else {
          html +=
            '<div class="lev-mc__vtex-order-no-items">Itens indisponíveis para este pedido.</div>';
        }
        html +=
          '</div>' +
          vtexOrderDetailsHtml(order, detailId, orderNumber, status) +
          '</div></article>';
      });

      box.innerHTML = html;
      hydrateVtexProductImages(box);
      box.setAttribute('data-loaded', '1');
      box.setAttribute('data-loaded-email', email);
    } catch (err) {
      console.error('[lev-minhaconta] vtex orders', err);
      box.innerHTML =
        '<div class="lev-mc__empty">Não foi possível carregar os pedidos do site agora.</div>';
    }
  }

  async function loadStoreOrders(force) {
    var box = qs('[data-store-orders]');
    if (!box) return;
    var email = ordersEmail();
    if (!email) {
      box.innerHTML =
        '<div class="lev-mc__empty">Informe um e-mail para buscar pedidos das lojas.</div>';
      return;
    }
    if (
      !force &&
      box.getAttribute('data-loaded') === '1' &&
      box.getAttribute('data-loaded-email') === email
    ) {
      return;
    }

    box.innerHTML = '<div class="lev-mc__status">Carregando pedidos das lojas…</div>';
    showMessage(qs('[data-client-search-error]'), '');

    try {
      var clientName = '';
      try {
        var userRes = await api('/api/sahnkya/get-user-by-email', {
          method: 'POST',
          body: JSON.stringify({ email: email }),
        });
        var userData = await userRes.json().catch(function () {
          return {};
        });
        if (userRes.ok && userData.data) {
          var sankhyaUser = Array.isArray(userData.data)
            ? userData.data[0]
            : userData.data;
          clientName =
            (sankhyaUser && (sankhyaUser.NOME || sankhyaUser.NOMEPARC)) || '';
        } else if (userRes.status === 404 && state.lookupEmail) {
          box.innerHTML =
            '<div class="lev-mc__empty">Cliente não encontrado no Sankhya para este e-mail.</div>';
          box.setAttribute('data-loaded', '1');
          box.setAttribute('data-loaded-email', email);
          return;
        }
      } catch (lookupErr) {
        console.warn('[lev-minhaconta] get-user-by-email', lookupErr);
      }

      var activeHint = qs('[data-client-search-active]');
      if (state.lookupEmail && activeHint) {
        activeHint.textContent =
          'Exibindo pedidos de: ' +
          email +
          (clientName ? ' (' + clientName + ')' : '');
        setHidden(activeHint, false);
      }

      var res = await api('/api/sahnkya/enhanced-client-data', {
        method: 'POST',
        body: JSON.stringify({ email: email }),
      });
      var data = await res.json().catch(function () {
        return {};
      });
      if (!res.ok) throw new Error(data.message || 'Erro ao buscar pedidos das lojas');

      var orders = Array.isArray(data.orders) ? data.orders : [];
      var bikes = Array.isArray(data.ownedProducts) ? data.ownedProducts : [];
      var html = '';

      if (bikes.length) {
        html +=
          '<div class="lev-mc__store-products"><h3 class="lev-mc__group-title">Dados da sua Lev</h3>';
        bikes.forEach(function (bike) {
          html +=
            '<div class="lev-mc__store-bike">' +
            storeDataRow('Produto:', bike.product || 'Bike') +
            (bike.color ? storeDataRow('Cor:', bike.color) : '') +
            (bike.chassisSerial ? storeDataRow('Chassi:', bike.chassisSerial) : '') +
            (bike.motorSerial ? storeDataRow('Motor:', bike.motorSerial) : '') +
            (bike.serialNumber ? storeDataRow('QR / Série:', bike.serialNumber) : '') +
            '</div>';
        });
        html += '</div>';
      }

      if (orders.length) {
        html +=
          '<div class="lev-mc__store-products"><h3 class="lev-mc__group-title">Pedidos de Produtos (' +
          orders.length +
          ')</h3><div class="lev-mc__store-orders">';
        orders.forEach(function (order) {
          var id =
            order.NUNOTA ||
            order.nunota ||
            order.orderId ||
            order.CODIGO ||
            order.id ||
            'Pedido';
          var date = formatDateBr(order.DTNEG || order.date || order.created_at || '');
          var total = formatMoneyBr(order.VLRNOTA || order.total || order.valor);
          var status = String(order.STATUSNOTA || order.status || '');
          var company = order.NOME_EMPRESA || order.company || '';
          var seller = order.NOME_VENDEDOR || order.seller || '';
          html +=
            '<article class="lev-mc__store-order"><div class="lev-mc__store-order-header">' +
            '<div><h4 class="lev-mc__store-order-title">Pedido #' +
            escapeHtml(String(id)) +
            '</h4><div class="lev-mc__store-order-nfe">NFe: ' +
            escapeHtml(String(id)) +
            '</div></div><div class="lev-mc__store-order-actions">' +
            (status
              ? '<span class="lev-mc__store-order-status" data-status="' +
                escapeHtml(status.toUpperCase()) +
                '">' +
                escapeHtml(getOrderStatus(status)) +
                '</span>'
              : '') +
            '<button type="button" class="lev-mc__store-order-pdf" data-download-nota="' +
            escapeHtml(String(id)) +
            '" title="Baixar Nota Fiscal PDF">Baixe sua nota aqui</button>' +
            '</div></div><div class="lev-mc__store-order-details">' +
            (company ? storeOrderDetail('Empresa:', company) : '') +
            (date ? storeOrderDetail('Data:', date) : '') +
            (total ? storeOrderDetail('Valor:', total) : '') +
            (seller ? storeOrderDetail('Vendedor:', seller) : '') +
            '</div></article>';
        });
        html += '</div></div>';
      }

      if (!html) {
        html = '<div class="lev-mc__empty">Nenhum pedido de loja encontrado para este e-mail.</div>';
      }

      box.innerHTML = html;
      box.setAttribute('data-loaded', '1');
      box.setAttribute('data-loaded-email', email);
    } catch (err) {
      console.error('[lev-minhaconta] store orders', err);
      box.innerHTML =
        '<div class="lev-mc__empty">Não foi possível carregar os pedidos das lojas agora.</div>';
      showMessage(
        qs('[data-client-search-error]'),
        (err && err.message) || 'Erro ao buscar pedidos das lojas.'
      );
    }
  }

  async function downloadNotaPdf(nunota, button) {
    var value = String(nunota || '').trim();
    if (!value || value === 'Pedido') {
      window.alert('Nota fiscal não disponível para este pedido.');
      return;
    }
    if (button) {
      button.disabled = true;
      button.textContent = 'Carregando…';
    }
    try {
      var res = await api('/api/sahnkya/generate-exact-pdf', {
        method: 'POST',
        body: JSON.stringify({ nunota: value }),
      });
      var data = await res.json().catch(function () {
        return {};
      });
      if (!res.ok) {
        throw new Error(
          data.error ||
            data.message ||
            'Não é possível gerar a segunda via desta nota fiscal.'
        );
      }
      var bodyHtml = data.bodyContent || data.html || '';
      var styleContent = data.styleContent || '';
      if (!bodyHtml) {
        throw new Error(
          'Não é possível gerar a segunda via desta nota fiscal.'
        );
      }

      // Build a full HTML document and open via Blob URL.
      // Do NOT use window.open(..., 'noopener') + document.write: modern
      // browsers return null from that open() even when the API succeeded,
      // which falsely looks like a popup-blocker issue.
      var fullHtml =
        '<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8"><title>DANFE ' +
        escapeHtml(value) +
        '</title><style>' +
        styleContent +
        '</style></head><body>' +
        bodyHtml +
        '</body></html>';
      var blob = new Blob([fullHtml], { type: 'text/html;charset=utf-8' });
      var blobUrl = URL.createObjectURL(blob);
      var win = window.open(blobUrl, '_blank');
      if (!win) {
        // Fallback: download the HTML if the tab couldn't open.
        var link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'DANFE-' + value + '.html';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.setTimeout(function () {
          try {
            win.focus();
            win.print();
          } catch (e) {}
        }, 500);
      }
      window.setTimeout(function () {
        try {
          URL.revokeObjectURL(blobUrl);
        } catch (e) {}
      }, 60000);
    } catch (err) {
      console.error('[lev-minhaconta] generate-exact-pdf', err);
      window.alert(
        (err && err.message) ||
          'Não é possível gerar a segunda via desta nota fiscal.'
      );
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = 'Baixe sua nota aqui';
      }
    }
  }

  function handleClientSearch() {
    var input = qs('[data-client-search-input]');
    var email = String((input && input.value) || '')
      .trim()
      .toLowerCase();
    if (!email || email.indexOf('@') === -1) {
      showMessage(qs('[data-client-search-error]'), 'Digite um email válido');
      return;
    }
    showMessage(qs('[data-client-search-error]'), '');
    setLookupEmail(email);
    resetStoreOrdersCache();
    loadStoreOrders(true);
  }

  function handleClearClientSearch() {
    showMessage(qs('[data-client-search-error]'), '');
    setLookupEmail('');
    var input = qs('[data-client-search-input]');
    if (input) input.value = state.email || '';
    resetStoreOrdersCache();
    loadStoreOrders(true);
  }

  function handleNewClientSearch() {
    showMessage(qs('[data-client-search-error]'), '');
    var input = qs('[data-client-search-input]');
    if (input) {
      input.value = '';
      input.focus();
    }
  }

  function storeDataRow(label, value) {
    return (
      '<div class="lev-mc__store-bike-row"><span>' +
      escapeHtml(label) +
      '</span><strong>' +
      escapeHtml(String(value || '—')) +
      '</strong></div>'
    );
  }

  function storeOrderDetail(label, value) {
    return (
      '<div class="lev-mc__store-order-detail"><span class="lev-mc__store-order-label">' +
      escapeHtml(label) +
      '</span><span class="lev-mc__store-order-value">' +
      escapeHtml(String(value)) +
      '</span></div>'
    );
  }

  function getOrderStatus(status) {
    var value = String(status || '').toUpperCase();
    if (value === 'A') return 'Aprovado';
    if (value === 'B') return 'Pendente';
    if (value === 'C') return 'Cancelado';
    return status || '—';
  }

  function formatDateBr(value) {
    if (!value) return '';
    var date = new Date(value);
    if (isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString('pt-BR');
  }

  function formatMoneyBr(value) {
    if (value === '' || value == null) return '';
    var number = Number(value);
    if (!isFinite(number)) return String(value);
    return number.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  async function loadLevPrime(forceBody) {
    try {
      var res = await api('/api/minhacontalev/levprime-status');
      var data = await res.json().catch(function () {
        return {};
      });
      var isPrime = !!(data && data.isLevPrime);
      // Never auto-show Lev Prime — only Ctrl+B then C unlocks the tab.
      if (!forceBody && !state.levPrimeVisible) return;

      var body = qs('[data-levprime-body]');
      if (!body) return;

      if (!isPrime) {
        body.innerHTML =
          '<div class="lev-mc__prime-promo">' +
          '<h3>Você ainda não é Prime</h3>' +
          '<div class="lev-mc__prime-line"></div>' +
          '<p>Percebemos que você ainda não tem o Lev Prime.</p>' +
          '<p>Que tal conhecer nosso novo plano</p>' +
          '<p><strong>Proteção<br>Até 15% Off</strong></p>' +
          '<p>Criamos o Lev Prime para quem pedala de Lev e quer aproveitar ainda mais a experiência com a sua bike.</p>' +
          '<p><strong>Venha descobrir todas as vantagens.</strong></p>' +
          '<a class="lev-mc__btn lev-mc__btn--save" href="/pages/levprime">Conheça o Lev Prime!</a>' +
          '</div>';
        return;
      }

      var modalidade = data.modalidade || '—';
      var modelo = data.modelo_lev || '—';
      var status = data.status || 'aprovado';
      var createdDate = data.created_at ? new Date(data.created_at) : null;
      var created =
        createdDate && !isNaN(createdDate.getTime())
          ? createdDate.toLocaleDateString('pt-BR')
          : '—';
      var year =
        createdDate && !isNaN(createdDate.getTime())
          ? String(createdDate.getFullYear())
          : '—';
      var modalidadeLabel =
        modalidade === 'semestral'
          ? 'Semestral'
          : modalidade === 'annual'
          ? 'Anual'
          : modalidade === 'monthly'
          ? 'Mensal'
          : modalidade;

      body.innerHTML =
        '<article class="lev-mc__prime-card">' +
        '<div class="lev-mc__prime-card-header">' +
        primeColumn('Lev Prime', '<span class="lev-mc__prime-pill">' + escapeHtml(getPrimeStatus(status)) + '</span>', true) +
        primeColumn('Lev', '<span class="lev-mc__prime-value">' + escapeHtml(String(modelo)) + '</span>') +
        primeColumn('Modalidade', '<span class="lev-mc__prime-value">' + escapeHtml(String(modalidadeLabel)) + '</span>') +
        primeColumn('Ano de vigência', '<span class="lev-mc__prime-value">' + escapeHtml(year) + '</span>') +
        '</div>' +
        '<div class="lev-mc__prime-card-body"><div class="lev-mc__prime-data">' +
        '<p>Data de início<strong>' +
        escapeHtml(created) +
        '</strong></p><p>Status da assinatura<strong>' +
        escapeHtml(getPrimeStatus(status)) +
        '</strong></p></div>' +
        '<div><p><strong>Minhas Coberturas</strong></p><p>Roubo</p><p>Furto Qualificado</p><p>Quebra Acidental</p></div>' +
        '<div><p><strong>Meus Benefícios</strong></p><p>Desconto de 15% no pagamento à vista em qualquer produto e serviço Lev.</p></div>' +
        '</div></article>';
    } catch (err) {
      console.error('[lev-minhaconta] levprime', err);
      if (forceBody) {
        var errBody = qs('[data-levprime-body]');
        if (errBody) {
          errBody.innerHTML =
            '<div class="lev-mc__prime-loading">Não foi possível carregar o status da assinatura agora.</div>';
        }
      }
    }
  }

  function primeColumn(label, content, title) {
    return (
      '<div class="lev-mc__prime-col"><span class="' +
      (title ? 'lev-mc__prime-col-title' : 'lev-mc__prime-label') +
      '">' +
      escapeHtml(label) +
      '</span><span class="lev-mc__prime-line"></span>' +
      content +
      '</div>'
    );
  }

  function getPrimeStatus(status) {
    return String(status || '').toLowerCase() === 'aprovado' ? 'Ativo' : String(status || '—');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function syncNavUser(email) {
    try {
      if (window.LevMinhaContaNav && typeof window.LevMinhaContaNav.setUser === 'function') {
        window.LevMinhaContaNav.setUser(email || null);
      }
    } catch (e) {}
  }

  function enterAccount(email) {
    state.email = email;
    syncNavUser(email);
    showApp();
    bindOnce();
    setLevPrimeVisible(false);
    loadProfile();
    applyTabFromLocation();
    redirectAfterLoginIfNeeded();
  }

  function redirectAfterLoginIfNeeded() {
    try {
      var params = new URLSearchParams(window.location.search);
      var ret = params.get('return');
      if (!ret || ret.charAt(0) !== '/') return;
      if (ret.indexOf('//') !== -1) return;
      if (ret.indexOf('/pages/minhacontalev') === 0) return;
      window.location.replace(ret);
    } catch (e) {}
  }

  async function logout() {
    try {
      await api('/api/minhacontalev/auth/logout', {
        method: 'POST',
        body: '{}',
      });
    } catch (err) {
      console.error('[lev-minhaconta] logout', err);
    }
    clearSession();
    syncNavUser(null);
    setClientSearchVisible(false);
    setLookupEmail('');
    resetVtexOrdersCache();
    var vtexBox = qs('[data-vtex-orders]');
    if (vtexBox) {
      vtexBox.innerHTML = '<div class="lev-mc__status">Carregando pedidos do site…</div>';
    }
    var storeBox = qs('[data-store-orders]');
    if (storeBox) {
      storeBox.removeAttribute('data-loaded');
      storeBox.removeAttribute('data-loaded-email');
      storeBox.innerHTML = '<div class="lev-mc__status">Carregando pedidos das lojas…</div>';
    }
    showGate();
  }

  function bindOnce() {
    if (state.bound) return;
    state.bound = true;

    qsa('[data-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTab(btn.getAttribute('data-tab'));
      });
    });

    qsa('[data-logout]').forEach(function (btn) {
      btn.addEventListener('click', logout);
    });

    var toggle = qs('[data-mobile-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var nav = qs('[data-mobile-nav]');
        var chevron = qs('[data-mobile-chevron]');
        var open = nav && nav.classList.toggle('is-open');
        if (chevron) chevron.classList.toggle('is-open', !!open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var profileEdit = qs('[data-profile-edit]');
    if (profileEdit) {
      profileEdit.addEventListener('click', function () {
        setEditMode('profile', true);
      });
    }
    var profileCancel = qs('[data-profile-cancel]');
    if (profileCancel) {
      profileCancel.addEventListener('click', function () {
        fillProfileForm(state.profileSnapshot || state.profile);
        setEditMode('profile', false);
        showMessage(qs('[data-profile-error]'), '');
      });
    }
    var profileForm = qs('[data-profile-form]');
    if (profileForm) profileForm.addEventListener('submit', saveProfile);

    var addressEdit = qs('[data-address-edit]');
    if (addressEdit) {
      addressEdit.addEventListener('click', function () {
        setEditMode('address', true);
      });
    }
    var addressCancel = qs('[data-address-cancel]');
    if (addressCancel) {
      addressCancel.addEventListener('click', function () {
        fillAddressForm(state.addressSnapshot || state.address);
        setEditMode('address', false);
        showMessage(qs('[data-address-error]'), '');
      });
    }
    var addressForm = qs('[data-address-form]');
    if (addressForm) addressForm.addEventListener('submit', saveAddress);

    var searchSubmit = qs('[data-client-search-submit]');
    if (searchSubmit) searchSubmit.addEventListener('click', handleClientSearch);
    var searchClear = qs('[data-client-search-clear]');
    if (searchClear) searchClear.addEventListener('click', handleClearClientSearch);
    var searchNew = qs('[data-client-search-new]');
    if (searchNew) searchNew.addEventListener('click', handleNewClientSearch);
    var searchInput = qs('[data-client-search-input]');
    if (searchInput) {
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleClientSearch();
        }
      });
    }

    var storeOrders = qs('[data-store-orders]');
    if (storeOrders) {
      storeOrders.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest
          ? e.target.closest('[data-download-nota]')
          : null;
        if (!btn) return;
        e.preventDefault();
        downloadNotaPdf(btn.getAttribute('data-download-nota'), btn);
      });
    }

    var vtexOrders = qs('[data-vtex-orders]');
    if (vtexOrders) {
      function toggleVtexOrder(toggle) {
        var panelId = toggle.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        var card = toggle.closest('.lev-mc__vtex-order');
        if (!panel || !card) return;
        var expanded = panel.hasAttribute('hidden');
        setHidden(panel, !expanded);
        qsa('[data-vtex-order-toggle]', card).forEach(function (control) {
          control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      }

      function toggleVtexOrderDetails(toggle) {
        var panelId = toggle.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (!panel) return;
        var expanded = panel.hasAttribute('hidden');
        setHidden(panel, !expanded);
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded
          ? 'Fechar detalhes'
          : 'Ver detalhes do pedido';
        if (expanded) {
          window.setTimeout(function () {
            panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 50);
        }
      }

      vtexOrders.addEventListener('click', function (e) {
        var detailToggle = e.target && e.target.closest
          ? e.target.closest('[data-vtex-order-details-toggle]')
          : null;
        if (detailToggle) {
          e.preventDefault();
          toggleVtexOrderDetails(detailToggle);
          return;
        }
        var toggle = e.target && e.target.closest
          ? e.target.closest('[data-vtex-order-toggle]')
          : null;
        if (!toggle) return;
        e.preventDefault();
        toggleVtexOrder(toggle);
      });
      vtexOrders.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var toggle = e.target && e.target.closest
          ? e.target.closest('[data-vtex-order-toggle]')
          : null;
        if (!toggle || toggle.tagName === 'BUTTON') return;
        e.preventDefault();
        toggleVtexOrder(toggle);
      });
    }

    // Reveal Lev Prime with Ctrl+B then C.
    // Open client order search (Meus Pedidos) with Ctrl+B then V.
    var expecting = false;
    var timer = null;
    window.addEventListener('keydown', function (e) {
      if (e.ctrlKey && e.key.toLowerCase() === 'b') {
        e.preventDefault();
        expecting = true;
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          expecting = false;
        }, 2000);
        return;
      }
      if (!expecting) return;

      if (e.key.toLowerCase() === 'c' || (e.ctrlKey && e.key.toLowerCase() === 'c')) {
        e.preventDefault();
        expecting = false;
        if (timer) clearTimeout(timer);
        var next = !state.levPrimeVisible;
        setLevPrimeVisible(next);
        if (next) {
          setTab('levprime');
          loadLevPrime(true);
        }
        return;
      }

      if (e.key.toLowerCase() === 'v') {
        e.preventDefault();
        expecting = false;
        if (timer) clearTimeout(timer);
        setTab('meuspedidos');
        setClientSearchVisible(!state.showClientSearch);
      }
    });
  }

  function bindAuthGate() {
    var emailForm = qs('[data-auth-email-form]');
    var codeForm = qs('[data-auth-code-form]');
    var backBtn = qs('[data-auth-back]');

    if (emailForm) {
      emailForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        var email = String(emailForm.email.value || '')
          .trim()
          .toLowerCase();
        if (!email || email.indexOf('@') === -1) {
          showMessage(qs('[data-auth-error]'), 'Digite um e-mail válido.');
          return;
        }
        showMessage(qs('[data-auth-error]'), '');
        state.pendingEmail = email;
        var submit = emailForm.querySelector('[type="submit"]');
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Enviando…';
        }
        try {
          var res = await api('/api/minhacontalev/auth/request-code', {
            method: 'POST',
            body: JSON.stringify({ email: email }),
          });
          var data = await res.json().catch(function () {
            return {};
          });
          if (!res.ok || !data.challenge) {
            throw new Error(data.message || 'Não foi possível enviar o código.');
          }
          state.challenge = data.challenge;
          setHidden(emailForm, true);
          setHidden(codeForm, false);
          var sub = qs('[data-auth-sub]');
          if (sub) {
            sub.textContent = data.devCode
              ? 'Modo local: use o código ' +
                data.devCode +
                ' (também no terminal da API).'
              : 'Enviamos um código de 6 dígitos para ' +
                email +
                '. Ele expira em 10 minutos.';
          }
          var hint = qs('[data-auth-hint]');
          if (hint && data.devCode) {
            hint.textContent = 'Código de desenvolvimento: ' + data.devCode;
          }
          if (codeForm.code) {
            if (data.devCode) codeForm.code.value = data.devCode;
            codeForm.code.focus();
          }
        } catch (err) {
          showMessage(
            qs('[data-auth-error]'),
            (err && err.message) || 'Não foi possível enviar o código.'
          );
        } finally {
          if (submit) {
            submit.disabled = false;
            submit.textContent = 'Continuar';
          }
        }
      });
    }

    if (codeForm) {
      codeForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        var code = String(codeForm.code.value || '').replace(/\D/g, '');
        if (code.length !== 6) {
          showMessage(qs('[data-auth-error]'), 'Digite o código de 6 dígitos.');
          return;
        }
        showMessage(qs('[data-auth-error]'), '');
        var submit = codeForm.querySelector('[type="submit"]');
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Confirmando…';
        }
        try {
          var res = await api('/api/minhacontalev/auth/verify-code', {
            method: 'POST',
            body: JSON.stringify({
              challenge: state.challenge,
              code: code,
            }),
          });
          var data = await res.json().catch(function () {
            return {};
          });
          if (!res.ok || !data.authenticated) {
            throw new Error(data.message || 'Código inválido ou expirado.');
          }
          if (data.token) setSessionToken(data.token);
          enterAccount(data.email || state.pendingEmail);
        } catch (err) {
          showMessage(
            qs('[data-auth-error]'),
            (err && err.message) || 'Código inválido ou expirado.'
          );
        } finally {
          if (submit) {
            submit.disabled = false;
            submit.textContent = 'Confirmar';
          }
        }
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        setHidden(codeForm, true);
        setHidden(emailForm, false);
        state.challenge = '';
        if (qs('[data-auth-sub]')) {
          qs('[data-auth-sub]').textContent =
            'Digite seu e-mail para acessar pedidos, dados e transferência de propriedade.';
        }
        showMessage(qs('[data-auth-error]'), '');
      });
    }
  }

  async function restoreSession() {
    try {
      var res = await api('/api/minhacontalev/auth/session');
      if (!res.ok) return false;
      var data = await res.json();
      if (!data.authenticated || !data.email) return false;
      enterAccount(data.email);
      return true;
    } catch (err) {
      console.error('[lev-minhaconta] restore session', err);
      return false;
    }
  }

  // —— boot ——
  if (!API_BASE) {
    var bootMissing = qs('[data-boot]') || qs('[data-auth-sub]');
    if (bootMissing) {
      bootMissing.textContent = 'API base URL não configurada.';
    }
    return;
  }

  if (MODE === 'page') {
    bindAuthGate();
    restoreSession().then(function (restored) {
      if (!restored) showGate();
    });
    return;
  }

  // Legacy customers/account.liquid path (Shopify customer email in data-email)
  state.email = String(ROOT.getAttribute('data-email') || '')
    .trim()
    .toLowerCase();
  if (!state.email) {
    var boot = qs('[data-boot]');
    if (boot) boot.textContent = 'Faça login para acessar sua conta.';
    return;
  }
  setHidden(qs('[data-auth-gate]'), true);
  setHidden(qs('[data-account-app]'), false);
  bindOnce();
  loadProfile();
  setLevPrimeVisible(false);
  applyTabFromLocation();
})();
